import { styled } from '@mui/styles'
import { Box as MuiBox, Box } from '@mui/material'

export const ModalContainer = styled(Box)(() => ({
  position: 'absolute',
  zIndex: 1,
  bottom: 72,
  left: 24,
}))

export const MapBuilding = styled(MuiBox)(({ theme, collapse, isexpanded }) => ({
  display: 'flex',
  position: 'relative',
  flexGrow: 1,
  overflow: 'hidden',
  border: `1px solid ${theme.palette.grey[200]}`,
  borderLeft: collapse ? `1px solid ${theme.palette.grey[200]}` : 0,
  borderRadius: isexpanded ? '24px' : '0 24px 24px 0',
  background: theme.palette.common.white,
  transition: 'all 0.3s ease-in-out',
  '& .react-transform-wrapper': {
    background: '#EFEFEF !important',
  },
  '& #mapSvg': {
    fill: 'none',
    stroke: 'red',
    strokeWidth: '1px',
    '& > svg': {
      fill: 'none',
      stroke: 'none',
    },
    '& > img': {
      fill: 'none',
      stroke: 'none',
    }
  },
}))